<!-- 创建专享消息发送计划 && 创建专享消息邀请计划 -->

<template>
  <div class="createSendPlan box-shadow" @click="closeEmoji">
    <!-- 标题栏 -->
    <div class="top-box">
      <div class="nav-box">
        <i class="iconfont iconicon_fanhui" style="color: #999; margin-right: 4px"></i>
        <span class="go-back" @click="goBack">返回列表</span>
        <span class="division"></span>
        <span class="title" v-if="sourceType == 1">{{ formData.id ? '修改' : '创建' }}专享消息发送计划</span>
        <span class="title" v-else>{{ formData.id ? '修改' : '创建' }}专享用户邀请计划</span>
      </div>
      <div class="tip-box" v-if="sourceType == 1">
        <div>
          <img src="@/assets/images/new_icon_reminder.png" alt="" />
        </div>
        <span>1.消息仅会发送给指定客服所属的专享用户；2.同一个用户每7天可收到同一商家日常触达的5条营销消息；</span>
      </div>
      <div class="tip-box" v-else>
        <div>
          <img style="margin-top:11px;" src="@/assets/images/new_icon_reminder.png" alt="" />
        </div>
        <div>
          <p>1.因官方邀请规则限制，批量邀请只会对符合“近30天咚咚咨询人群”范围的用户推送消息；</p>
          <p>2.同一个用户1天最多可接收5条邀请开通专属客服卡片消息，同一个用户每7天最多收到同一个商家的1条邀请消息；</p>
        </div>
      </div>
    </div>
    <!-- 编辑信息 -->
    <div class="createForm">
      <!-- 第一步 筛选人群 -->
      <div class="step-box">
        <div class="step-bar">
          <span class="serial" :style="{ background: globalBG }">1</span>
          <span class="name" style="margin-left: -10px">筛选人群</span>
        </div>
        <div class="step_form">
          <div class="form-item">
            <div class="item-label require">计划名称：</div>
            <div class="item-value activity-theme">
              <el-input :placeholder="sourceType == 1 ? '输入发送计划名称' : '输入邀请计划名称'" v-model="formData.activityName"
                maxlength="50" show-word-limit></el-input>
            </div>
          </div>
          <!-- 选择人群 -->
          <div class="form-item">
            <div class="item-label require">{{ sourceType == 1 ? "发送对象：" : "邀请对象：" }}</div>
            <div class="item-value activity-theme">
              <div class="select-people-box">
                <div class="select-header">
                  <el-button type="primary" @click="showPeopleDialog('0')" :disabled="computeLoading || peopleDis"
                    style="margin-right: 12px; font-size: 14px; height: 28px">选择人群</el-button>
                  <span>已选</span>
                  <span class="height-num" style="color: #fe4d45">{{
    includePeople.length
  }}</span>
                  <span>个人群</span>
                  <div class="operation-wrapper">
                    <span>运算规则：</span>
                    <el-radio-group v-model="includeRule" :disabled="computeLoading || peopleDis">
                      <el-radio :label="1">合并</el-radio>
                      <el-radio :label="0">交集</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="people-group">
                  <div class="group-item" v-for="(item, index) in includePeople" :key="index"
                    :style="item.count > 0 ? '' : 'border-color:#FE4D45'">
                    <div class="group-name">
                      {{ item.name || item.strategyName }}
                      <span :style="{ color: item.count > 0 ? '#7f85e9' : '#FE4D45' }">（{{ item.count }}）</span>
                    </div>
                    <div class="close" @click="delPeople('0', index)" v-if="!peopleDis"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 排除人群 -->
          <div class="form-item">
            <div class="item-label"></div>
            <div class="item-value">
              <el-checkbox v-model="isExcludeFlag" :disabled="computeLoading || peopleDis" :label="true"
                style="z-index: 0;">&nbsp;排除人群</el-checkbox>
            </div>
          </div>
          <div class="form-item" v-if="isExcludeFlag">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="select-people-box">
                <div class="select-header">
                  <el-button class="computeLoadingButtom" style="margin-right: 12px"
                    :disabled="computeLoading || peopleDis" @click="showPeopleDialog('1')">选择人群</el-button>
                  <span>已选</span>
                  <span class="height-num" style="color: #fe4d45">{{ excludePeople.length }}</span>
                  <span>个人群</span>
                  <div class="operation-wrapper">
                    <span>运算规则：</span>
                    <el-radio-group v-model="excludeRule" :disabled="computeLoading || peopleDis">
                      <el-radio :label="1">合并</el-radio>
                      <el-radio :label="0">交集</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="people-group">
                  <div class="group-item" v-for="(item, index) in excludePeople" :key="index"
                    :style="item.count > 0 ? '' : 'border-color:#FE4D45'">
                    <div class="group-name">
                      {{ item.name || item.strategyName
                      }}<span :style="{ color: item.count > 0 ? '#7f85e9' : '#FE4D45' }">（{{ item.count }}）</span>
                    </div>
                    <div class="close" @click="delPeople('1', index)" v-if="!peopleDis"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 过滤设置 -->
          <div class="form-item">
            <div class="item-label"></div>
            <div class="item-value">
              过滤设置
              <div class="ask_content">
                <el-popover placement="right" width="350" trigger="hover" content="仅支持过滤黑名单pin，不支持过滤黑名单手机号。">
                  <span class="question_icon" slot="reference" style="margin-left: 4px">?</span>
                </el-popover>
              </div>
            </div>
          </div>
          <!-- 屏蔽黑名单 -->
          <div class="form-item">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="select-people-box">
                <div class="select-header aacc">
                  <el-checkbox id="select-header-color" :label="true" :disabled="computeLoading || peopleDis"
                    v-model="blacklisted" style="z-index: 0;">
                    屏蔽黑名单
                  </el-checkbox>
                  <span @click="routerLinkOne" :style="{ color: '#7f85e9' }"
                    style="margin-left: 10px; cursor: pointer; margin-right: 20px">设置黑名单</span>
                  <el-checkbox v-if="isPremissionShow" :label="true" :disabled="computeLoading || peopleDis"
                    v-model="filterAlreadySentFlag" style="z-index: 0;">
                    <span>屏蔽近</span>
                    <el-input v-model.number="filterDays" @keyup.native="limitInput($event)" :disabled="peopleDis"
                      onblur="value=value.replace(/[^\d]/g,'')" style="width: 100px; padding: 0 6px">
                    </el-input>
                    <span>天已发送客户</span>
                  </el-checkbox>
                </div>
              </div>
            </div>
          </div>
          <!-- 人群运算 -->
          <div class="form-item">
            <div class="item-label require">人群运算结果：</div>
            <div class="item-value">
              <span>共筛选出<span :style="{ color: globalBG, margin: '0 8px' }">{{ sendPeopleNum }}</span>人</span>
              <el-button class="handleCaculateButtom" @click="handleCaculate" :disabled="computeLoading || peopleDis"
                v-loading="computeLoading">点击运算</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 第二步 编辑消息内容 -->
      <div class="step-box">
        <div class="step-bar">
          <span class="serial" :style="{ background: globalBG }">2</span>
          <span class="name" style="margin-left: -10px">编辑消息内容</span>
        </div>
        <div class="step_form" v-if="sourceType == 1">
          <div class="form-item">
            <div class="item-label require">发送客服：</div>
            <div class="item-value">
              <el-select v-model="formData.waiter" style="width:280px;">
                <el-option v-for="item, index in waiterList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
              <el-popover placement="right" width="400" trigger="hover">
                <div>温馨提示：官方接口原因无法过滤无效账号，为避免选择了无效客服账号导致消息发送失败，请选择客服账号前先到官方平台<a style="cursor: pointer;color:blue;"
                    @click="jumpJD">kf.jd.com</a>核实客服账号是否正常。</div>
                <img style="width:14px;vertical-align:middle;margin-left:8px;cursor: pointer;" slot="reference"
                  src="@/assets/images/dongdong/tips_wenhao.png" alt="" />
              </el-popover>
            </div>
          </div>
          <div class="form-item">
            <div class="item-label require">消息类型：</div>
            <div class="item-value">
              <el-radio-group v-model="formData.messageType" class="radioGroup">
                <el-radio :label="1">商品推荐</el-radio>
                <el-radio :label="2">图文消息</el-radio>
                <el-radio :label="3">文本消息</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="form-item">
            <div class="item-label require">消息内容：</div>
            <div class="item-value">
              <!-- 编辑消息内容盒子 -->
              <div>
                <!-- 商品推荐 -->
                <div class="msg_box" v-if="formData.messageType == 1">
                  <div class="form-item">
                    <div class="item-label require" style="width:97px;">消息标题:</div>
                    <div class="item-value" style="width:500px;">
                      <el-input style="width:500px;" v-model="formData.massTheme" maxlength="14"
                        show-word-limit></el-input>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="item-label" style="width:97px;">邀请语:</div>
                    <div class="item-value" style="width:500px;">
                      <el-input type="textarea" v-model="formData.invitationText" :rows="3" style="width:500px;"
                        maxlength="50" show-word-limit></el-input>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="item-label require" style="width:97px;">显示方式:</div>
                    <div class="item-value" style="width:500px;">
                      <el-radio-group v-model="formData.showType" class="radioGroup">
                        <el-radio :label="2">列表模式</el-radio>
                        <el-radio :label="1">大图模式</el-radio>
                      </el-radio-group>
                      <div style="margin-top:6px;color:#7F85E9;">列表模式支持选择1-4个商品，大图模式支持2-6个商品</div>
                      <el-button :style="{ color: globalBG, borderColor: globalBG, marginTop: '12px' }"
                        @click="addGoods">添加商品({{ selectGoodsList.length }})</el-button>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="item-label require" style="width:97px;">按钮显示:</div>
                    <div class="item-value" style="width:500px;">
                      <el-radio-group v-model="formData.isShowBtn" class="radioGroup">
                        <el-radio :label="0">不显示底部按钮</el-radio>
                        <el-radio :label="1">显示底部按钮</el-radio>
                        <el-input style="margin-left:-20px;" v-model="formData.jumpUrl" v-if="formData.isShowBtn == 1"
                          placeholder="输入跳转链接"></el-input>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
                <!-- 图文消息 -->
                <div class="msg_box" v-if="formData.messageType == 2">
                  <div class="form-item">
                    <div class="item-label require" style="width:97px;">展示方式:</div>
                    <div class="item-value" style="width:500px;">
                      <el-radio-group v-model="formData.picStyle" class="radioGroup">
                        <el-radio :label="1">上图下文</el-radio>
                        <el-radio :label="2">左图右文</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="item-label require" style="width:97px;">消息标题:</div>
                    <div class="item-value" style="width:500px;">
                      <el-input style="width:450px;" v-model="formData.massTheme" maxlength="14"
                        show-word-limit></el-input>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="item-label require" style="width:97px;">消息图片:</div>
                    <div class="item-value" style="width:500px;position:relative;">
                      <el-upload ref="upload" action="#" :show-file-list="false" :auto-upload="false" :limit="1"
                        accept=".jpg, .png, jpeg" :on-change="handleChange">
                        <img class="upload-img" v-if="formData.picUrl" :src="formData.picUrl" alt="" />
                        <div v-else class="upload-box">
                          <i class="iconfont iconbtn_zidingyitianjia"></i>
                          <div class="text">上传图片</div>
                        </div>
                      </el-upload>
                      <div class="upload_tips">图片尺寸765*360px，支持jpg，jpeg，png格式</div>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="item-label require" style="width:97px;">描述文字:</div>
                    <div class="item-value" style="width:500px;">
                      <el-input type="textarea" v-model="formData.textMessageContent" :rows="4" style="width:450px;"
                        maxlength="36" show-word-limit></el-input>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="item-label require" style="width:97px;">跳转地址:</div>
                    <div class="item-value" style="width:500px;">
                      <el-input style="width:450px;" v-model="formData.jumpUrl" placeholder="H5或原生地址"></el-input>
                    </div>
                  </div>
                </div>
                <!-- 文本消息 -->
                <div class="msg_box" v-if="formData.messageType == 3">
                  <div class="form-item">
                    <div class="item-label require" style="width:97px;">描述文字:</div>
                    <div class="item-value" style="width:500px;position:relative;">
                      <!-- <div class="emoji_top">
                        <div @click.stop="showEmoji"><img src="@/assets/images/face.png" /></div>
                      </div> -->
                      <el-input type="textarea" id="myInput" v-model="formData.textMessageContent" :rows="8"
                        style="width:450px;" maxlength="140" show-word-limit></el-input>
                      <!-- emoji表情 -->
                      <!-- <picker v-show="emojiShow" class="emoji_box" :showSearch="false" :showPreview="false"
                        :showCategorise="false" @select="addEmoji" :i18n="I18N" /> -->
                    </div>
                  </div>
                </div>
                <div class="msg_box" style="padding-top: 0;"
                  v-if="formData.messageType != 1 || (formData.messageType == 1 && formData.isShowBtn == 1)">
                  <div class="form-item">
                    <div class="item-label" style="width:97px;">辅助工具:</div>
                    <div class="tool">
                      <p @click.prevent="handleShowShortLink">
                        <i class="iconfont iconbtn_duanwangzhi"></i>
                        插入短网址
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="step_form" v-if="sourceType == 2">
          <div class="form-item">
            <div class="item-label require">发送客服：</div>
            <div class="item-value">
              <el-input disabled style="width:280px;" v-model="formData.waiter"></el-input>
              <el-popover placement="right" width="340" trigger="hover">
                <div>由主账号发出邀请卡片，客户开通后将随机分配给已配置客服（用户数均等为原则）</div>
                <img style="width:14px;vertical-align:middle;margin-left:8px;cursor: pointer;" slot="reference"
                  src="@/assets/images/dongdong/tips_wenhao.png" alt="" />
              </el-popover>
            </div>
          </div>
          <div class="form-item">
            <div class="item-label">引导语：</div>
            <div class="item-value">
              <el-input type="textarea" v-model="formData.welcomeContent" :rows="3" style="width:500px;" maxlength="56"
                show-word-limit placeholder="非必填，客户端对内容不做截断，建议56个汉字长度内"></el-input>
            </div>
          </div>
          <div class="form-item">
            <div class="item-label require">标题：</div>
            <div class="item-value">
              <el-input style="width:500px;" v-model="formData.massTheme" maxlength="14" show-word-limit
                placeholder="必填，超过1行客户端截断尾部打3点，建议14汉字长度内"></el-input>
            </div>
          </div>
          <div class="form-item">
            <div class="item-label">邀请语：</div>
            <div class="item-value">
              <el-input v-model="formData.invitationText" disabled style="width:500px;"></el-input>
              <div class="tips_yellow">
                <img style="width:14px;vertical-align:middle;margin-left:8px;"
                  src="@/assets/images/new_icon_waring_yellow.png" />
                邀请语非必填，以商家后台配置为准，超过4行客户端截断尾部打3点，建议4行56个汉字长度内
              </div>
            </div>
          </div>
          <!-- <div class="form-item" style="display:flex;">
            <div class="item-label">权益配置：</div>
            <div class="item-value">
              <div class="quanyi_box">
                <div class="quanyi_icon">
                  <img src="@/assets/images/hot_mrq.png" alt="">
                  <span>图标名称</span>
                </div>
                <div class="quanyi_icon">
                  <img src="@/assets/images/hot_mrq.png" alt="">
                  <span>图标名称</span>
                </div>
                <div class="quanyi_icon">
                  <img src="@/assets/images/hot_mrq.png" alt="">
                  <span>图标名称</span>
                </div>
                <div class="quanyi_icon">
                  <img src="@/assets/images/hot_mrq.png" alt="">
                  <span>图标名称</span>
                </div>
              </div>
              <div class="tips_yellow">
                <img style="width:14px;vertical-align:middle;margin-left:8px;"
                  src="@/assets/images/new_icon_waring_yellow.png" />
                权益图标，名称，以商家后台配置的为准
              </div>
            </div>
          </div> -->
        </div>
        <!-- 手机预览图 -->
        <div class="phone_box" :class="sourceType == 2 ? 'phone_box2' : ''">
          <div class="phone_inner" v-if="sourceType == 1">
            <div class="phone_left">
              <img src="@/assets/images/dongdong/touxiang.png" alt="">
            </div>
            <div class="phone_right">
              <span>客服</span>
              <!-- 商品推荐 -->
              <div class="phone_content" v-if="formData.messageType == 1">
                <div class="phone_title">{{ formData.massTheme }}</div>
                <div class="phone_invite">{{ formData.invitationText }}</div>
                <!-- 列表模式 -->
                <div class="phone_list" v-for="item, index in selectGoodsList" :key="index">
                  <div class="list_item" v-if="formData.showType == 2 && index < 4">
                    <div><img :src="item.logo"></div>
                    <div class="goods_info">
                      <div>{{ item.skuName }}</div>
                      <div>￥{{ item.jdPrice }}</div>
                    </div>
                  </div>
                </div>
                <!-- 大图模式 -->
                <div class="phone_imgList" v-if="formData.showType == 1">
                  <div class="goods_imgBox" v-for="item, index in selectGoodsList" :key="index" v-if="index < 6">
                    <img :src="item.logo">
                    <div>￥{{ item.jdPrice }}</div>
                  </div>
                </div>
                <div class="showMore" v-if="formData.isShowBtn">查看更多</div>
              </div>
              <!-- 图文消息 -->
              <div class="phone_content" v-if="formData.messageType == 2">
                <!-- 上图下文 -->
                <div v-if="formData.picStyle == 1">
                  <img style="width: 164px;height: 80px;border-radius: 8px;" :src="formData.picUrl"
                    v-if="formData.picUrl">
                  <div style="width: 164px;height: 80px;border-radius: 8px;background: #f3f4f5;" v-else></div>
                  <div class="phone_title" style="margin-top: 8px;">{{ formData.massTheme }}</div>
                  <div class="phone_invite">{{ formData.textMessageContent }}</div>
                </div>
                <!-- 左图右文 -->
                <div v-if="formData.picStyle == 2">
                  <div class="phone_title">{{ formData.massTheme }}</div>
                  <div style="display: flex;align-items: center;margin-top: 8px;">
                    <img style="width: 50px;height: 50px;border-radius: 8px;margin-right: 4px;" :src="formData.picUrl"
                      v-if="formData.picUrl">
                    <div style="width: 180px;height: 50px;border-radius: 8px;margin-right: 4px;background: #f3f4f5;"
                      v-else></div>
                    <div style="font-size: 10px;color: #999999;line-height: 13px;">{{ formData.textMessageContent }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- 文本消息 -->
              <div class="phone_content" v-if="formData.messageType == 3">
                {{ formData.textMessageContent }}
              </div>
            </div>
          </div>
          <div class="phone_inner" v-if="sourceType == 2">
            <div class="phone_left">
              <img src="@/assets/images/dongdong/touxiang.png" alt="">
            </div>
            <div class="phone_right">
              <div class="phone_content">
                <div class="phone_title">{{ formData.welcomeContent }}</div>
              </div>
            </div>
          </div>
          <div class="phone_inner" v-if="sourceType == 2" style="margin-top:0px;">
            <div class="phone_left">
              <img src="@/assets/images/dongdong/touxiang.png" alt="">
            </div>
            <div class="phone_right">
              <div class="phone_content">
                <div class="phone_title">{{ formData.massTheme }}</div>
                <div class="phone_invite">{{ formData.invitationText }}</div>
                <div class="openFW">开启服务</div>
                <!-- <div class="quanyi_icon">
                  <div>
                    <img src="@/assets/images/hot_mrq.png" alt="">
                    <span>图标名称</span>
                  </div>
                  <div>
                    <img src="@/assets/images/hot_mrq.png" alt="">
                    <span>图标名称</span>
                  </div>
                  <div>
                    <img src="@/assets/images/hot_mrq.png" alt="">
                    <span>图标名称</span>
                  </div>
                  <div>
                    <img src="@/assets/images/hot_mrq.png" alt="">
                    <span>图标名称</span>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第三步 发送时间 -->
      <div class="step-box">
        <div class="step-bar">
          <span class="serial" :style="{ background: globalBG }">3</span>
          <span class="name" style="margin-left: -10px">发送时间</span>
        </div>
        <div class="step_form">
          <div class="form-item">
            <div class="item-label require">发送方式：</div>
            <div class="item-value" style="margin-bottom: 30px;">
              <el-radio-group v-model="formData.sendType" style="display: flex;align-items: center;height: 32px;"
                :disabled="formData.id !== ''">
                <el-radio :label="0">立即发送</el-radio>
                <el-radio :label="1">定时发送</el-radio>
                <el-date-picker v-if="formData.sendType == 1" v-model="formData.sendTime1" @change="dateChange"
                  @blur="updata" type="date" class="pickerChange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  placeholder="选择日期" :picker-options="expireTimeOption1" style="width: 136px"></el-date-picker>
                <el-time-picker v-model="formData.sendTime2" v-if="formData.sendType == 1" format="HH:mm:ss"
                  @blur="updata" class="pickerChange1" :picker-options="expireTimeOption2" value-format="HH:mm:ss"
                  placeholder="选择时间" style="margin-left: 8px;margin-right: 8px;width: 136px;"></el-time-picker>
                <el-radio :label="2">循环发送</el-radio>
              </el-radio-group>
              <div class="xhSend" v-if="formData.sendType == 2">
                <div class="form-item">
                  <div class="item-label" style="width:97px;">活动时间:</div>
                  <div class="item-value" style="width:500px;position:relative;">
                    <div class="my_select_time">
                      <el-date-picker prefix-icon="no_icon" v-model="formData.cycleStartTime" type="datetime"
                        :placeholder="'选择日期时间'" size="small" format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="startTimeOption" value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 120px; font-size: 12px" class="time1" :clearable="false"></el-date-picker>
                      <div class="time_to_text" style="margin-top: 1px !important">
                        至
                      </div>
                      <el-date-picker prefix-icon="no_icon" v-model="formData.cycleEndTime" type="datetime"
                        :placeholder="'选择日期时间'" :picker-options="endTimeOption" size="small"
                        format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 145px; font-size: 12px" default-time="23:59:59" class="time2"
                        :clearable="false"></el-date-picker>
                      <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
                      <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
                    </div>
                  </div>
                </div>
                <div class="form-item">
                  <div class="item-label" style="width:97px;">推送时间:</div>
                  <div class="item-value" style="width:540px;position:relative;">
                    <el-radio-group v-model="formData.cycleExecutionType"
                      style="display: flex;align-items: center;height: 32px;">
                      <el-radio :label="0">按天</el-radio>
                      <el-radio :label="1">按周</el-radio>
                      <el-radio :label="2">按月</el-radio>
                    </el-radio-group>
                    <div v-if="formData.cycleExecutionType == 0" style="margin: 8px 0">
                      每<el-input-number v-model="formData.cycleDay" style="margin: 0 8px;width:100px;"
                        :min="1"></el-input-number>天
                    </div>
                    <div v-if="formData.cycleExecutionType == 1"
                      style="margin: 12px 0;display: flex;align-items: center;">
                      <div>每周：</div>
                      <el-checkbox-group v-model="formData.cycleDayWeekly">
                        <el-checkbox label="2" style="width:30px;">周一</el-checkbox>
                        <el-checkbox label="3" style="width:30px;">周二</el-checkbox>
                        <el-checkbox label="4" style="width:30px;">周三</el-checkbox>
                        <el-checkbox label="5" style="width:30px;">周四</el-checkbox>
                        <el-checkbox label="6" style="width:30px;">周五</el-checkbox>
                        <el-checkbox label="7" style="width:30px;">周六</el-checkbox>
                        <el-checkbox label="1" style="width:30px;">周日</el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div v-if="formData.cycleExecutionType == 2" style="margin: 12px 0;display: flex;">
                      <div style="width:150px;margin-top:3px;">每月:</div>
                      <el-checkbox-group v-model="formData.cycleDayMonthly">
                        <el-checkbox :value="item.value" :label="item.label" style="width:30px;"
                          v-for="item in monthOptions" :key="item.value"></el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div>
                      每天推送时间点:
                      <el-time-picker v-model="formData.cycleExecutionTime" format="HH:mm:ss" class="pickerChange1"
                        value-format="HH:mm:ss" placeholder="选择时间"
                        style="margin-left: 8px;margin-right: 8px;width: 136px;"></el-time-picker>
                    </div>
                    <div v-if="formData.cycleExecutionType == 0" style="font-size: 13px;margin-top: 8px;color:#7F85E9">
                      例如1号开始发送，选择每1天，则每天都会发送；选择每2天，则下一次会在3号进行发送。</div>
                    <div v-if="formData.cycleExecutionType == 2" style="font-size: 13px;margin-top: 8px;color:#7F85E9">
                      如遇当月没有29、30、31的情况则会直接跳过不执行任务</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部提交按钮 -->
    <div class="footer">
      <el-button :style="{ color: globalBG, borderColor: globalBG }" @click="goBack">关闭</el-button>
      <el-button type="primary" @click="submitForm">提交发送</el-button>
    </div>
    <!-- 选择人群 -->
    <select-people :peopleList="showSelectPeople" v-if="selectPeopleDialog" @onConfirm="handleSelectPeople"
      @onCancle="selectPeopleDialog = false" :selectPeopleDialog="selectPeopleDialog"></select-people>
    <!-- 选择商品 -->
    <selectGoods :isShow="selectGoodsShow" :selectGoods="selectGoodsList" @close="selectGoodsChange" :skuSearch="true"
      :moduleType="true"></selectGoods>
    <!-- 插入短链接 -->
    <insert-short-dialog v-if="insertShortUrlShow" :strategyInstId="computeData.strategyInstId"
      @close="handleCloseShort"></insert-short-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Picker } from "emoji-mart-vue"; //引入emoji组件
import selectPeople from "@/components/select-people.vue"; // 选择人群
import selectGoods from "@/components/selectGoodsMonitor"; // 选择商品
import insertShortDialog from "@/components/insert-short-dialog"; // 插入短链
// api
import { caculateMember } from "@/api/memberLabel"; // 计算人群
import { packStatus } from "@/api/memberCrowd";
import { uploadpic } from "@/api/marketing/dongdong"; // 上传图片
import { getWaiterList, getInviteTxt, exclusiveWaiterSend, exclusiveWaiterUpdate } from "@/api/marketing/dongdong";
import { getSendTime } from "@/api/smsSend";
import { crowdCount } from "@/api/smsSend";
export default {
  components: {
    selectPeople,
    selectGoods,
    Picker,
    insertShortDialog
  },
  props: {
    // 1 发送计划  2 邀请计划
    sourceType: {
      type: Number,
      default: 1
    },
    editForm: {
      type: Object
    }
  },
  data() {
    return {
      formData: {
        id: "",
        activityName: "",
        waiter: "", // 发送客服
        messageType: 1, // 消息类型
        massTheme: "", // 消息标题
        invitationText: "", // 邀请语
        welcomeContent: "",  // 引导语
        showType: 2, // 显示方式
        isShowBtn: 0, // 按钮显示
        jumpUrl: "", // 跳转链接
        picStyle: 1, // 展示方式
        picUrl: "", // 上传图片
        textMessageContent: "", // 描述文字
        sendType: 0,
        sendTime1: "", // 定时发送 日期
        sendTime2: "", // 定时发送 时间
        cycleExecutionType: 0, // 推送时间类型
        cycleDay: 1, // 按天 时间间隔
        cycleDayWeekly: [], // 每周
        cycleDayMonthly: [], // 每月
        cycleExecutionTime: "", // 循环发送 每天推送时间点
      },
      /** 选择人群相关参数 */
      selectPeopleDialog: false, // 选择人群弹窗
      showSelectPeople: [],
      includePeople: [], // 选择人群
      excludePeople: [], // 排除人群
      peopleType: 0, // 0.表示 选择人群 1.表示排除人群
      includeRule: 1,
      excludeRule: 1, // 删除人群运算规则1.合并 0.交集
      isExcludeFlag: false, // 是否勾选排除人群
      blacklisted: false, // 是否勾选黑名单列表
      filterAlreadySentFlag: false, // 是否勾选过滤几天已发送的客户
      filterDays: "", // 过滤多少天
      isPremissionShow: true, // 屏蔽近X天发送客户的权限
      computeData: {
        // 计算人群数量
        count: 0,
        strategyInstId: "", // 人群测试id
      },
      computeLoading: false, // 计算人群loading
      requestNum: 20, // 挖宝重复请求次数
      sendPeopleNum: 0, // 筛选的会员数
      crowdStatus: false, // 人群包状态
      /** end  */
      waiterList: [], // 发送客服列表
      // 选择商品相关参数
      selectGoodsShow: false, // 选择商品弹窗
      selectGoodsList: [], // 已选商品列表
      // emoji表情配置
      emojiShow: false,
      I18N: {
        search: '搜索',
        notfound: 'No Emoji Found',
        categories: {
          search: '搜索结果',
          recent: '经常使用',
          smileys: '表情与情感',
          people: '人物与身体',
          nature: '动物与自然',
          foods: '食物与饮料',
          activity: '活动',
          places: '旅行与地理',
          objects: '物品',
          symbols: '符号标志',
          flags: '旗帜',
          custom: 'Custom',
        },
      },
      limitTime: {}, // 官方发送时间限制
      // 时间配置
      expireTimeOption1: {
        disabledDate(date) {
          return (
            date.getTime() < Date.now() - 8.64e7 ||
            date.getTime() > Date.now() + 8.64e7 * 90
          );
        },
      },
      expireTimeOption2: {
        selectableRange: "9:00:00 - 19:55:59",
      },
      startTimeOption: {
        disabledDate: (date) => {
          var endTime = this.formData.cycleEndTime;
          var time = date.getTime();
          var isDisabled = false;
          if (endTime) {
            isDisabled = time > new Date(endTime).getTime();
          }
          return (
            isDisabled ||
            date.getTime() < Date.now() - 8.64e7
          );
        }
      },
      endTimeOption: {
        disabledDate: (date) => {
          var startTime = this.formData.cycleStartTime;
          var time = date.getTime();
          var isDisabled = false;
          if (startTime) {
            isDisabled = time < new Date(startTime).getTime();
          }
          return (
            isDisabled ||
            date.getTime() < Date.now() - 8.64e7
          );
        }
      },
      monthOptions: [],
      peopleDis: false,
      insertShortUrlShow: false, // 短链接弹窗
      sourceUrl: "",
    }
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
  },
  watch: {
    // 权限判断
    permissions(nVal, oVal) {

    },
    isExcludeFlag(nVal, oVal) {
      this.sendPeopleNum = 0;
    },
    includePeople() {
      this.sendPeopleNum = 0;
    },
    excludePeople() {
      this.sendPeopleNum = 0;
    },
    includeRule() {
      this.sendPeopleNum = 0;
    },
    excludeRule() {
      this.sendPeopleNum = 0;
    },
  },
  created() {
    // 修改回显
    if (this.editForm.id) {
      console.log('this.editForm', this.editForm);
      this.peopleDis = true
      this.formData = { ...this.editForm };
      if (this.formData.isCopy) { // 复制-清除id
        this.formData.id = ""
        this.peopleDis = false
        console.log(this.formData, '=======================copy');
      }
      if (this.editForm.sendTime) {
        this.formData.sendTime1 = this.editForm.sendTime.split(" ")[0];
        this.formData.sendTime2 = this.editForm.sendTime.split(" ")[1];
      }
      this.selectGoodsList = [];
      this.editForm.skus.forEach(item => {
        this.selectGoodsList.push({
          logo: item.image,
          skuId: item.skuId,
          jdPrice: item.price,
          skuName: item.skuName,
          wareTitle: item.skuName,
          itemUrl: item.url
        })
      })
      this.includePeople = this.editForm.selectedCrowd.includeSearchId;
      this.excludePeople = this.editForm.selectedCrowd.excludeSearchId || [];
      this.includeRule = Number(this.editForm.selectedCrowd.includeRule);
      if (this.editForm.excludeRule) this.excludeRule = this.editForm.selectedCrowd.excludeRule - 0;
      this.isExcludeFlag = this.editForm.selectedCrowd.excludeFlag == "1" ? true : false
      this.blacklisted = this.editForm.selectedCrowd.blacklisted
      this.filterAlreadySentFlag = this.editForm.selectedCrowd.filterAlreadySentFlag
      this.filterDays = this.editForm.selectedCrowd.filterDays || ""
      this.formData.cycleDayWeekly = this.editForm.cycleDayWeekly ? this.editForm.cycleDayWeekly.split(",") : []
      this.formData.cycleDayMonthly = this.editForm.cycleDayMonthly ? this.editForm.cycleDayMonthly.split(",") : []
      var selectedCrowd = this.editForm.selectedCrowd;
      // 获取人群包数量
      if (selectedCrowd) {
        if (this.includePeople.length > 0) {
          let precisionCrowdStrategyIds = this.includePeople.map(
            (item) => item.precisionCrowdStrategyId
          );
          crowdCount({
            precisionCrowdStrategyIds: precisionCrowdStrategyIds,
          }).then((val) => {
            this.includePeople = this.includePeople.map((item) => {
              let obj = item;
              val.data.forEach((ele) => {
                if (
                  item.precisionCrowdStrategyId ==
                  ele.precisionCrowdStrategyId
                ) {
                  obj.count = ele.count;
                }
              });
              return obj;
            });
          });
        }
        if (this.excludePeople.length > 0) {
          let precisionCrowdStrategyIds = this.excludePeople.map(
            (item) => item.precisionCrowdStrategyId
          );
          crowdCount({
            precisionCrowdStrategyIds: precisionCrowdStrategyIds,
          }).then((val) => {
            this.excludePeople = this.excludePeople.map((item) => {
              let obj = item;
              val.data.forEach((ele) => {
                if (
                  item.precisionCrowdStrategyId ==
                  ele.precisionCrowdStrategyId
                ) {
                  obj.count = ele.count;
                }
              });
              return obj;
            });
          });
        }
      }
    }
  },
  mounted() {
    for (var i = 1; i < 32; i++) {
      let obj = { label: i + '', value: i }
      this.monthOptions.push(obj)
    }
    this.limitSendTime()
    // 获取发送客服
    this.getWaiterList()
    // 获取邀请语
    if (this.sourceType == 2) {
      getInviteTxt().then(res => {
        this.formData.invitationText = res.data
      })
    }
  },
  methods: {
    // 显示短链弹窗
    handleShowShortLink() {
      this.insertShortUrlShow = true;
    },
    // 关闭短链接
    handleCloseShort(val, obj) {
      this.insertShortUrlShow = false;
      if (val) {
        this.sourceUrl = obj.originUrl;
        if (this.formData.messageType != 3) {
          this.formData.jumpUrl = obj.shortLink
        } else {
          this.formData.textMessageContent = this.formData.textMessageContent + " " + obj.shortLink + " "
        }
      }
    },
    jumpJD() {
      window.open('http://kf.jd.com');
    },
    // 提交发送
    submitForm() {
      if (!this.formData.activityName) {
        return this.$message.warning("请输入计划名称")
      }
      if (this.computeLoading) {
        return this.$message.warning("正在计算人群，请计算完人群再进行下一步操作哦~");
      }
      if (this.sendPeopleNum == "0") {
        if (!this.formData.id) {
          return this.$message.warning("人群数为0，无法进行下一步操作哦~ 请重新选择人群计算");
        }
      }
      if (!this.formData.waiter) {
        return this.$message.warning("发送客服不能为空！")
      }
      if (this.sourceType == 1) { // 专享消息发送
        if (this.formData.messageType == 1) { // 商品推荐
          if (!this.formData.massTheme) {
            return this.$message.warning("请输入消息标题")
          }
          if (!this.selectGoodsList.length) {
            return this.$message.warning("请先添加商品！")
          }
          if (this.formData.isShowBtn == 1 && !this.formData.jumpUrl) {
            return this.$message.warning("请输入跳转链接")
          }
        } else if (this.formData.messageType == 2) { // 图文消息
          if (!this.formData.massTheme) {
            return this.$message.warning("请输入消息标题")
          }
          if (!this.formData.picUrl) {
            return this.$message.warning("消息图片不能为空！")
          }
          if (!this.formData.textMessageContent) {
            return this.$message.warning("请输入描述文字")
          }
          if (!this.formData.jumpUrl) {
            return this.$message.warning("请输入跳转地址")
          }
        } else if (this.formData.messageType == 3) { // 文本消息
          if (!this.formData.textMessageContent) {
            return this.$message.warning("请输入描述文字")
          }
        }
      } else { // 专享消息邀请
        if (!this.formData.massTheme) {
          return this.$message.warning("请输入消息标题")
        }
      }
      if (this.formData.sendType == 1) {
        if (!this.formData.sendTime1 || !this.formData.sendTime2) {
          return this.$message.warning("请选择发送时间")
        }
        let year1 = new Date().getFullYear() + 1;
        let path = this.formData.sendTime1.split("-");
        let year2 = parseInt(path[0]);
        let month1 = parseInt(path[1]);
        let month2 = month1 + 1 < 10 ? "0" + month1 + 1 : month1 + 1;
        let date1 = parseInt(path[2]);
        let date2 = new Date(year2, month1, 0).getDate();
        let month3 = "01";
        let date3 = "01";
        let date4 = date1 + 1 < 10 ? "0" + date1 + 1 : date1 + 1;
        let path1 = this.formData.sendTime2.split(":");
        let end =
          parseInt(path1[0]) * 3600 +
          parseInt(path1[1]) * 60 +
          parseInt(path1[2]);
        let time1 = 25200;
        let time2 = 79200;
        if (end < time1) {
          this.formData.sendTime2 = "07:00:00";
        } else if (end >= time2) {
          if (date2 == date1 && month1 == 12) {
            this.formData.sendTime1 = `${year1}-${month3}-${date3}`;
            this.formData.sendTime2 = "07:00:00";
          } else if (date2 == date1 && month1 < 12) {
            this.formData.sendTime1 = `${year2}-${month2}-${date3}`;
            this.formData.sendTime2 = "07:00:00";
          } else if (date2 < date1) {
            this.formData.sendTime1 = `${year2}-${month2}-${date4}`;
            this.formData.sendTime2 = "07:00:00";
          }
        }
      } else if (this.formData.sendType == 2) {
        if (!this.formData.cycleStartTime || !this.formData.cycleEndTime) {
          return this.$message.warning("请选择循环发送活动时间")
        }
        let isOK = false
        if (this.formData.cycleExecutionType == 1 && !this.formData.cycleDayWeekly.length) {
          isOK = true
        }
        if (this.formData.cycleExecutionType == 2 && !this.formData.cycleDayMonthly.length) {
          isOK = true
        }
        if (!this.formData.cycleExecutionTime) {
          isOK = true
        }
        if (isOK) {
          return this.$message.warning("请选择推送时间")
        }
      }
      this.messageSend()
    },
    // 发送消息
    messageSend() {
      console.log(this.formData);
      let param = {
        activityName: this.formData.activityName, // 计划名称
        source: this.sourceType == 1 ? 0 : 1, // 来源 0发送专享消息 1邀请专享用户
        sendType: this.formData.sendType, // 发送类型 0立即 1定时 2循环
        waiter: this.formData.waiter, // 发送客服
        messageType: this.formData.messageType, // 消息类型
        massTheme: this.formData.massTheme, // 消息标题
        invitationText: this.formData.invitationText, // 邀请语
        showType: this.formData.showType, // 商品推荐-显示方式
        isShowBtn: this.formData.isShowBtn, // 商品推荐-按钮显示
        picStyle: this.formData.picStyle, // 图文推荐-展示方式
        picUrl: this.formData.picUrl, // 消息图片
        textMessageContent: this.formData.textMessageContent, // 描述文字
        jumpUrl: this.formData.jumpUrl, // 跳转地址
        welcomeContent: this.formData.welcomeContent, // 引导语
        skus: [], // 推荐商品
      }
      if (!this.formData.id) { // 创建新发送
        param.filterAlreadySentFlag = this.filterAlreadySentFlag ? 1 : 0 // 是否过滤近几天已发送的客户
        param.filterBlacklistFlag = this.blacklisted ? 1 : 0 // 是否过滤黑名单
        param.filterDays = this.filterDays // 过滤天数
        param.sendSubmitNum = this.sendPeopleNum // 发送提交人数
        param.strategyInstId = this.computeData.strategyInstId // 人群实例化id
      }
      if (param.sendType == 1) { // 定时发送
        param.sendTime = this.formData.sendTime1 + " " + this.formData.sendTime2
      } else if (param.sendType == 2) { // 周期发送
        param.cycleStartTime = this.formData.cycleStartTime // 活动开始时间
        param.cycleEndTime = this.formData.cycleEndTime // 活动结束时间
        param.cycleExecutionType = this.formData.cycleExecutionType // 周期执行方式
        param.cycleExecutionTime = this.formData.cycleExecutionTime // 每日具体执行时间
        if (param.cycleExecutionType == 0) {
          param.cycleDay = this.formData.cycleDay // 每XX天
        } else if (param.cycleExecutionType == 1) {
          param.cycleDayWeekly = this.formData.cycleDayWeekly.join(",") // 每周几
        } else if (param.cycleExecutionType == 2) {
          param.cycleDayMonthly = this.formData.cycleDayMonthly.join(",") // 每月几号
        }
      }
      this.selectGoodsList.forEach(item => {
        let obj = {
          skuId: item.skuId,
          skuName: item.skuName,
          image: item.logo,
          url: item.itemUrl,
          price: item.jdPrice,
        }
        param.skus.push(obj)
      })
      console.log("提交的参数====>", param);
      if (this.formData.id) { // 修改 -- 人群相关不可修改
        param.id = this.formData.id
        exclusiveWaiterUpdate(param).then(res => {
          if (res.code == 1) {
            this.$message.success(res.message)
            this.$emit("onBack", this.sourceType)
          } else {
            this.$message.error(res.message)
          }
        }).catch(() => {
          this.$message.error(res.message)
        })
      } else { // 创建发送
        exclusiveWaiterSend(param).then(res => {
          if (res.code == 1) {
            this.$message.success(res.message)
            this.$emit("onBack", this.sourceType)
          } else {
            this.$message.error(res.message)
          }
        }).catch(() => {
          this.$message.error(res.message)
        })
      }
    },
    // 获取发送客服列表
    getWaiterList() {
      let param = {
        isPrimary: this.sourceType == 1 ? false : true
      }
      getWaiterList(param).then(res => {
        this.waiterList = res.data || []
        if (this.sourceType == 2 && this.waiterList.length) {
          this.formData.waiter = this.waiterList[0]
        }
      })
    },
    // 打开emoji表情框  通过.stop阻止事件冒泡 不会触发关闭表情弹窗
    showEmoji() {
      this.emojiShow = !this.emojiShow
    },
    // 选择表情
    addEmoji(e) {
      if (this.formData.textMessageContent.length > 138) return
      const myInput = document.getElementById("myInput");
      //光标位置
      const startPos = myInput.selectionStart;
      const endPos = myInput.selectionEnd;
      //添加到光标位置
      const emoji = e.native;
      const inputTxt = myInput.value;
      const result = inputTxt.substring(0, startPos) + emoji + inputTxt.substring(endPos);
      myInput.value = result;
      //重新定位光标位置
      myInput.selectionStart = startPos + emoji.length;
      myInput.selectionEnd = startPos + emoji.length;
      myInput.focus();
      //赋值
      this.formData.textMessageContent = result;
    },
    // 关闭表情  点击页面任意位置都会关闭表情弹窗
    closeEmoji(e) {
      this.emojiShow = false
    },
    // 点击添加商品
    addGoods() {
      this.selectGoodsShow = true
    },
    // 选择商品
    selectGoodsChange(val, item) {
      this.selectGoodsShow = false
      if (!val) return
      if (val.length > 6) {
        this.selectGoodsList = val.splice(0, 6)
        this.$message.warning("最多仅支持添加6个商品！")
      } else {
        this.selectGoodsList = val
      }
    },
    // 上传图片
    handleChange(file, fileList) {
      // const isLtSize = file.size < 1024 * 1024 * 0.5;
      // if (!isLtSize) {
      //   this.$message.error("限制格式: jpg、jpeg、png，请上传小于500k的图片！");
      //   this.$refs.upload.clearFiles();
      // } else {
      let formdata = new FormData();
      formdata.append("file", file.raw);
      uploadpic(formdata).then((res) => {
        // 获取图片真实url
        if (res.code === 1) {
          this.formData.picUrl = res.data;
          this.$refs.upload.clearFiles();
        } else {
          this.$message.error(res.message);
        }
      });
      // }
    },
    // 显示选择人群弹窗
    showPeopleDialog(type) {
      this.peopleType = type;
      if (type == "0") {
        this.showSelectPeople = this.includePeople;
      } else if (type == "1") {
        this.showSelectPeople = this.excludePeople;
      }
      this.selectPeopleDialog = true;
    },
    // 返回选择的人群
    handleSelectPeople(obj) {
      this.selectPeopleDialog = false;
      if (this.peopleType == "0") {
        // 包含人群
        this.includePeople = obj;
      } else if (this.peopleType == "1") {
        // 排除人群
        this.excludePeople = obj;
      }
    },
    // 删除人群
    delPeople(type, index) {
      if (this.computeLoading) {
        return;
      }
      if (type == "0") {
        this.includePeople.splice(index, 1);
      } else if (type == "1") {
        this.excludePeople.splice(index, 1);
      }
    },
    // 跳转 前往设置黑名单
    routerLinkOne() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 点击运算人群
    handleCaculate() {
      if (!this.includePeople.length) {
        this.$message.error("请先选择人群");
        return
      }
      // 3.2新增需求 人群数为0无法运算
      if (this.includePeople.filter(item => item.count == 0).length) {
        this.$message.error("所选人群中存在数量为0人群，请删除该人群后再进行运算");
        return
      }
      var excludeStrategyIdList = [];
      var excludeFlag = this.isExcludeFlag ? "1" : "0";
      var includeIds = [];
      var excludeIds = [];
      var includeSearchIds = [];
      var excludeSearchIds = [];

      if (excludeFlag == "1" && this.excludePeople.length == "0") {
        // 勾选排除人群，限制必须选择人群
        this.$message.warning("请先选择排除人群哦~");
        return;
      }
      if (
        this.isPremissionShow &&
        this.filterAlreadySentFlag &&
        !this.filterDays
      ) {
        this.$message.warning("屏蔽天数不能为空哦~");
        return;
      }

      this.includePeople.forEach((item, index) => {
        var temp = {
          precisionCrowdStrategyId: item.precisionCrowdStrategyId,
          name: item.name,
          count: item.count,
        };
        if (item.searchId && item.searchId.length > 0) {
          temp.searchId = item.searchId;
          includeSearchIds.push(temp);
        } else {
          temp.strategy = item.strategy;
          includeIds.push(temp);
        }
      });

      this.excludePeople.forEach((item) => {
        var temp = {
          precisionCrowdStrategyId: item.precisionCrowdStrategyId,
          name: item.name,
        };

        if (item.searchId && item.searchId.length > 0) {
          temp.searchId = item.searchId;
          excludeSearchIds.push(temp);
        } else {
          temp.strategy = item.strategy;
          excludeIds.push(temp);
        }
      });
      var param = {
        source: 1,
        includeRule: this.includeRule, // 0 交集 1.并集
        excludeFlag, // 0 不选择排除人群 1. 选择
        includeSearchId: includeSearchIds,
        includeCrowd: includeIds,
      };
      if (this.sourceType == 1) {
        // this.$message.error("测试用注释，后期去除")
        param.isIntersectionExclusive = true
      }
      if (this.isExcludeFlag) {
        param.excludeSearchId = excludeSearchIds;
        param.excludeCrowd = excludeIds;
        param.excludeRule = this.excludeRule;
      }
      this.computeLoading = true;
      this.requestNum = 20;
      var paramX = {
        selectedCrowd: JSON.stringify(param),
      };
      param.blacklisted = this.blacklisted;
      param.filterAlreadySentFlag = this.filterAlreadySentFlag;
      param.filterDays = this.filterDays;
      this.sendPeopleNum = 0;
      caculateMember(param).then((res) => {
        this.computeLoading = false;
        if (res.code == "1") {
          // 遍历循环挖包
          this.computeData.strategyInstId = res.data.strategyInstId;
          this.handlePackStatus();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 重复挖包
    handlePackStatus() {
      this.requestNum--;
      var that = this;
      if (this.requestNum < 1) {
        this.$message.error("筛选人群失败");
        this.computeLoading = false;
        return;
      }
      var param = {
        strategyInstId: this.computeData.strategyInstId,
      };
      this.computeLoading = true;
      setTimeout(() => {
        packStatus(param).then((res) => {
          if (res.code == "1") {
            this.computeLoading = false;
            this.sendPeopleNum = res.data.crowdSize; // 人群数量
            this.crowdStatus = res.data.crowdStatus; // 人群包状态
          } else {
            var timeout = setTimeout(function () {
              that.handlePackStatus();
            });
          }
        });
      }, 1000);
    },
    // 输入限制
    limitInput(event) {
      if (event.target.value == "0") {
        event.target.value = "";
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, "");
      }
    },
    // 清除时间
    clearTimeSendTime() {
      this.formData.cycleStartTime = '';
      this.formData.cycleEndTime = '';
    },
    updata() {
      this.$forceUpdate()
    },
    // 选择日期
    dateChange(val) {
      var nowTime10 = this.getNowDate2();
      var time1 = nowTime10.substring(0, 10);
      var time2 = nowTime10.substring(11, 19);
      var startTime = this.limitTime.startTime;
      var endTime = this.limitTime.endTime;
      // var time2 = "20:58:59";
      var arr = time2.split(":");
      var endArr = endTime.split(":");

      // 最晚可以选到时间
      if (arr[0] > endArr[0]) {
        time2 = endTime;
      } else if (arr[0] == endArr[0] && arr[1] > endArr[1]) {
        time2 = endTime;
      } else if (
        arr[0] == endArr[0] &&
        arr[1] == endArr[1] &&
        arr[2] >= endArr[2]
      ) {
        time2 = endTime;
      }

      // 选择时间为空
      this.formData.sendTime2 = "";

      if (val == time1) {
        this.expireTimeOption2.selectableRange = time2 + " - " + endTime;
      } else {
        this.expireTimeOption2.selectableRange = startTime + " - " + endTime;
      }
    },
    // 获取当前时间
    getNowDate2() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }

      date.setMinutes(date.getMinutes() + 10);
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();

      if (Hours >= 0 && Hours <= 9) {
        Hours = "0" + Hours;
      }
      if (Minutes >= 0 && Minutes <= 9) {
        Minutes = "0" + Minutes;
      }
      if (Seconds >= 0 && Seconds <= 9) {
        Seconds = "0" + Seconds;
      }

      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        Hours +
        seperator2 +
        Minutes +
        seperator2 +
        Seconds;
      return currentdate;
    },
    // 官方发送，发送时间的限制
    limitSendTime() {
      getSendTime().then((res) => {
        this.limitTime = res.data;
        var selectableRange = res.data.startTime + " - " + res.data.endTime;
        this.expireTimeOption2.selectableRange = selectableRange;
      });
    },
    // 返回列表
    goBack() {
      this.$emit("onBack", this.sourceType);
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/.pickerChange .el-icon-date:before {
  content: "\E78E";
  position: absolute;
  left: 107px;
}

/deep/.pickerChange1 .el-icon-time:before {
  content: "\E71F";
  position: absolute;
  left: 107px;
}

.tool {
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  top: 5px;

  p {
    box-sizing: border-box;
    padding: 0 8px;
    margin: 0 8px 0 0;
    height: 32px;
    line-height: 28px;
    font-size: 14px;
    border-radius: 3px;
    background-color: #f7f8fe;
    border: 1px solid #7f85e9;
    color: #7f85e9;

    &:hover {
      background: rgba(174, 179, 241, 0.16);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9 !important;
    }

    &:active {
      background: rgba(174, 179, 241, 0.24);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9;
    }
  }
}

.createSendPlan {
  margin: 11px 20px;
  min-width: 1220px;

  .box-shadow {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    background: #fff;
  }

  .top-box {
    // margin-bottom: 20px;
    // padding: 0 30px;
    // padding-bottom: 10px;

    .nav-box {
      height: 54px;
      line-height: 54px;
      border-bottom: 1px solid #f0f0f0;
      // padding-left: 27px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 30px;
    }

    .go-back {
      font-size: 14px;
      color: #999999;
      vertical-align: middle;
      cursor: pointer;
      height: 54px;
      flex-shrink: 0;

      &:hover {
        color: #fe4d45;
      }
    }

    .division {
      display: inline-block;
      vertical-align: middle;
      margin: 0 20px;
      width: 1px;
      height: 20px;
      background: #cccccc;
    }

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #2e3458;
      vertical-align: middle;
      margin-right: 8px;
      height: 54px;
      flex-shrink: 0;
    }

    .tip-box {
      background: #FAFAFA;
      color: #333333;
      border-radius: 3px;
      line-height: 18px;
      padding: 12px;
      display: flex;
      width: 95%;
      margin: auto;
      margin-top: 18px;

      span {
        vertical-align: middle;
      }

      img {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-top: -2px;
        margin-right: 8px;
      }
    }
  }

  .createForm {
    padding: 0 28px;
    padding-top: 16px;

    .step-box {
      position: relative;

      .step-bar {
        position: relative;
        padding-left: 12px;
        margin-left: 29px;
        // margin-bottom: 20px;
        width: -webkit-calc(100% - 80px);
        width: -moz-calc(100% - 80px);
        width: calc(100% - 80px);

        .serial {
          width: 22px;
          height: 22px;
          border-radius: 22px;
          color: #fff;
          line-height: 23px;
          text-align: center;
          display: inline-block;
          position: absolute;
          left: -29px;
          top: 50%;
          transform: translateY(-50%);
        }

        .name {
          font-size: 14px;
          color: #333;
          font-weight: 500;
          line-height: 32px;
          vertical-align: middle;
        }
      }

      .phone_box2 {
        top: -50px !important;
      }

      .phone_box {
        width: 255px;
        height: 503px;
        background-image: url("../../../assets/images/dongdong/phone.png");
        background-size: cover;
        margin-left: 50px;
        position: absolute;
        top: 60px;
        left: 800px;
        word-break: break-all;

        .phone_inner {
          display: flex;
          margin-top: 74px;
          padding-left: 18px;

          .phone_left {
            img {
              height: 30px;
              height: 30px;
            }
          }

          .phone_right {
            padding-left: 4px;
            padding-top: 3px;
            color: #333333;

            >span {
              font-size: 12px;
            }

            .phone_content {
              width: 180px;
              border-radius: 8px;
              background: #FFFFFF;
              padding: 8px;
              margin-top: 4px;
              color: #333333;
              letter-spacing: 2px;
              line-height: 18px;

              .phone_title {
                font-weight: 400;
                font-size: 12px;
              }

              .phone_invite {
                margin-top: 4px;
                color: #999999;
                font-size: 10px;
                line-height: 14px;
              }
              .openFW{
                color: white;
                background: #fe4d45;
                width: 96px;
                height: 23px;
                line-height: 23px;
                border-radius: 10px;
                text-align: center;
                margin-left: 34px;
                font-size: 12px;
              }

              .list_item {
                display: flex;
                width: 100%;
                height: 46px;
                margin-top: 8px;

                img {
                  width: 46px;
                  height: 46px;
                  border-radius: 4px;
                }

                .goods_info {
                  margin-left: 8px;
                  font-size: 10px;
                  line-height: 14px;
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  padding: 1px 0;

                  >div:nth-of-type(1) {
                    -webkit-line-clamp: 2;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                }
              }

              .phone_imgList {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                width: 100%;
              }

              .goods_imgBox {
                width: 78px;
                height: 78px;
                border-radius: 4px;
                overflow: hidden;
                margin-top: 8px;
                position: relative;

                img {
                  width: 100%;
                }

                >div {
                  border-radius: 0px 4px 0px 4px;
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  background: rgba(0, 0, 0, 0.5);
                  color: #FFFFFF;
                  font-size: 10px;
                  line-height: 16px;
                  padding: 0 5px;
                }
              }

              .showMore {
                text-align: center;
                font-size: 10px;
                border-top: 1px solid #dadada;
                padding-top: 5px;
                margin-top: 8px;
              }

              .quanyi_icon {
                display: flex;
                justify-content: space-evenly;
                margin-top: 8px;

                >div {
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  font-size: 8px;

                  img {
                    width: 24px;
                    height: 24px;
                    margin: auto;
                  }
                }
              }
            }
          }
        }
      }
    }

    .step_form {
      border-left: 1px solid #DDDDDD;
      margin-left: 10px;
      margin-top: -4px;
      padding-top: 24px;
      padding-bottom: 10px;
    }
  }

  .form-item {
    margin-bottom: 16px;

    &>div {
      display: inline-block;
    }

    .item-label {
      width: 145px;
      text-align: right;
      padding-right: 8px;
      box-sizing: border-box;
      vertical-align: text-top;
      line-height: 32px;
      color: #333333;
    }

    .require {
      &:before {
        content: "*";
        color: red;
        margin-right: 4px;
      }
    }

    .item-value {
      width: 902px;
      vertical-align: text-top;
    }
  }

  .select-people-box {
    .select-header {
      @media screen and (max-width: 1366px) {
        width: 800px;
      }

      background: #f6f6f6;
      position: relative;
      padding: 8px;

      .computeLoadingButtom {
        width: 98px;
        height: 28px;
        color: #fe4d45;
        border-radius: 3px;
        border: 1px solid #fe4d45;
        background-color: #fff;

        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }

        &:active {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }

      .height-num {
        color: #7f85e9;
        margin: 0 4px;
      }

      .operation-wrapper {
        position: absolute;
        right: 20px;
        transform: translateY(-50%);
        top: 50%;
      }
    }

    .people-group {
      border: 1px solid rgba(246, 246, 246, 1);
      color: #999;
      padding-top: 14px;

      .group-item {
        position: relative;
        display: inline-block;
        line-height: 32px;
        height: 32px;
        border: 1px solid rgba(238, 238, 238, 1);
        border-radius: 2px;
        color: #666666;
        margin-left: 10px;
        margin-bottom: 14px;
        position: relative;

        .group-name {
          display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: center;
          overflow: hidden;
          padding: 0 12px;
        }

        .close {
          display: none;
          position: absolute;
          right: -6px;
          top: -6px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          cursor: pointer;
          background-color: #fe4d45;

          &:before,
          &:after {
            position: absolute;
            top: 4px;
            left: 7px;
            content: " ";
            height: 8px;
            width: 2px;
            background-color: #fff;
          }

          &:before {
            transform: rotate(45deg);
          }

          &:after {
            transform: rotate(-45deg);
          }
        }

        &:hover .close {
          display: inline-block;
        }
      }
    }
  }

  .ask_content {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin-right: 2px;
    cursor: pointer;

    .question_icon {
      width: 14px;
      height: 14px;
      color: #7f85e9 !important;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #7f85e9;
      font-size: 12px !important;
      font-weight: normal !important;
      margin-left: 8px;

      &:hover {
        color: #fe4d45 !important;
        border: 1px solid #fe4d45;
      }
    }

    .ask-icon {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      position: relative;
    }

    .contentButtom {
      color: #7f85e9;

      &:hover {
        color: #fe4d45;
      }
    }
  }

  .handleCaculateButtom {
    width: 98px;
    height: 32px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    border-radius: 3px;
    background-color: #fff4f4;
    font-size: 14px;
    margin-left: 10px;

    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .msg_box {
    padding-top: 20px;
    // padding-left: 10px;
    padding-bottom: 10px;
    width: 650px;
    background: #FAFAFA;
    // display: inline-block;
  }

  .footer {
    border-top: 1px solid #f6f6f6;
    padding: 20px;
    padding-left: 35px;
    margin-left: -25px;
    text-align: center;
  }

  .radioGroup {
    display: flex;
    align-items: center;
    height: 32px;
  }

  .upload-img {
    width: 100px;
    height: 100px;
  }

  .upload_tips {
    position: absolute;
    left: 120px;
    top: 10px;
    color: #969696;
  }

  .upload-box {
    width: 100px;
    height: 100px;
    border: 1px dashed #eeeeee;
    background: #ffffff;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    i {
      color: #999;
      font-size: 12px;
    }

    .text {
      margin-top: 7px;
      font-size: 12px;
      color: #666;
    }
  }

  .emoji_top {
    width: 450px;
    height: 30px;
    border: 1px solid #dcdfe6;
    border-bottom: transparent;
    margin-bottom: -2px;

    >div {
      width: 30px;
      height: 30px;
      cursor: pointer;
    }

    img {
      width: 18px;
      margin-top: 4px;
      margin-left: 6px;
    }
  }

  .emoji_box {
    position: absolute;
    height: 350px;
    top: -350px;
    left: 0;
    z-index: 1;
  }

  .xhSend {
    padding-top: 20px;
    padding-bottom: 10px;
    width: 650px;
    background: #FAFAFA;
  }

  .tips_yellow {
    display: inline-block;
    border: 1px solid #FFD9A5;
    border-radius: 2px;
    background: #FFFAEE;
    line-height: 15px;
    padding: 6px 0;
    padding-right: 14px;
    margin-top: 12px;
    color: #333333;

    img {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
  }

  .quanyi_box {
    display: flex;

    .quanyi_icon {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 20px;

      img {
        width: 40px;
        height: 40px;
        margin: auto;
      }
    }
  }
}
</style>